import React from 'react'

import { Button, Tooltip, useCopyToClipboard, useMediaQueryContext } from '@fourthwall/components'

import * as S from './styled'

type CopyInputProps = {
  label: string
  buttonLabel: string
  content: string
}

export const CopyInput = ({ label, buttonLabel, content }: CopyInputProps) => {
  const media = useMediaQueryContext()

  const { isCopied, copyToClipboard } = useCopyToClipboard({
    toastMessage: !media.laptop ? 'Copied!' : undefined,
  })

  return (
    <S.Container>
      <S.Inner>
        <S.Label>{label}</S.Label>
        <S.Content>{content}</S.Content>
      </S.Inner>
      {isCopied && media.laptop ? (
        <Tooltip
          reference={
            <Button
              appearance="secondary"
              label={buttonLabel}
              fullWidth
              onClick={() => copyToClipboard(content)}
            />
          }
        >
          Copied
        </Tooltip>
      ) : (
        <div>
          <Button
            appearance="secondary"
            label={buttonLabel}
            fullWidth
            onClick={() => copyToClipboard(content)}
          />
        </div>
      )}
    </S.Container>
  )
}
